import React from 'react';
import { useTranslation } from 'react-i18next';
import { HOST_SERVER } from '../../utils/configs';
import ngologo from '../../assets/ngologo.png';
import LoadingGIF from "../../assets/loadingIn.gif";

// Re-export initializeSsoSession service function for modular structure
export { initializeSsoSession } from '../../services/ssoAuthService';

export default function SSOLoginButton({
  isSSOLoggingIn,
  setisSSOLoggingIn,
  setLoginMessage,
}) {
  const { t } = useTranslation();

  const onSSOLogin = () => {
    setisSSOLoggingIn(true);
    if (setLoginMessage) {
      setLoginMessage({ text: "" });
    }

    // Redirect to the Google OAuth2 endpoint — backend handles the consent redirect
    window.location.href = `${HOST_SERVER}/auth/google`;
  };

  return (
    <>
      <div className="sso-divider">
        <span>OR</span>
      </div>
      <button
        id="sso-google-signin-btn"
        type="button"
        className="sso-sign-in-button"
        onClick={onSSOLogin}
        disabled={isSSOLoggingIn}
      >
           {!  isSSOLoggingIn ? (
            <>
              <img src={ngologo} className="sso-icon" alt="Forthcode SSO" />
              {t('pages.loginContent.ssoSignIn')}
            </>
          ) : (
            <img
              src={LoadingGIF}
              className="loading-icon"
              alt="Loading"
            />
          )}
      </button>
    </>
  );
}
